import { PostAPI, PostAPIWithoutRequest } from "../helper/apiHelper";


export const InsertPropertyDetails = async (request: any) => {
  return PostAPI(request, 'ResidentialPropertyDetails/Insert');
};

export const InsertPropertyOwnerDetails = async (request: any) => {
  return PostAPI(request, 'PropertyOwnerMaster/Insert');
};

export const InsertPropertySpecification = async (request: any) => {
  return PostAPI(request, 'ResidentialPropertySpecifications/Insert');
};

export const InsertFinancialDetails = async (request: any) => {
  return PostAPI(request, 'ResidentialProperty/Insert');
};

export const SelectAmenitiesType = async () => {
  return PostAPIWithoutRequest('AmenitiesType/SelectAmenitiesType');
};

export const InsertSelectedAmenities = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/InsertAmenities');
};

export const InsertFiles = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/InsertMultipleFiles');
};

export const SelectOwner = async (request: any) => {
  return PostAPI(request,'PropertyOwnerMaster/SelectByUserID');
};

export const SelectResidentialDetails = async (request: any) => {
  return PostAPI(request,'ResidentialPropertyDetails/SelectByUserID');
};

export const SelectPropertySpecification = async (request: any) => {
  return PostAPI(request,'ResidentialPropertySpecifications/SelectByUserID');
};

export const SelectFinancialDetails = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/SelectByUserID');
};

export const SelectedAmenities = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/SelectAmenities');
};

export const SelectMultipleFiles = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/SelectFilesByUserID');
};

export const deleteFile = async (request: any) => {
  return PostAPI(request,'ResidentialProperty/Delete');
};

export const SearchProperty = async (request: any) => {
  return PostAPI(request,'ResidentialPropertyDetails/SearchProperties');
};